import React, {Component} from "react"
import PropTypes from "prop-types"
import {get, isArray, isString, cloneDeep} from "lodash"

import {Http403} from "@irati/ui/src/Errors"

import id from "../id"

/**
 * Helper to determine if I have all required permissions
 *
 * @param permissions {array|string}
 * @returns {boolean}
 */
export const doIHavePermission = (permissions, apps) => {
  if (!permissions) {
    return true
  }
  let hasPermission = true
  let requestedPermissions = cloneDeep(permissions)
  if (requestedPermissions && isString(requestedPermissions)) requestedPermissions = [requestedPermissions]
  if (!isArray(requestedPermissions)) throw new Error("Provide a string or an array of strings as permissions")

  requestedPermissions.forEach((permission) => {
    hasPermission = !get(apps, permission) ? false : hasPermission
  })

  return hasPermission
}

class RouteHasPermissionTo extends Component {
  static contextTypes = {
    authed: PropTypes.object.isRequired
  }

  static propTypes = {
    permissions: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
    children: PropTypes.node,
    Error: PropTypes.node,
    auth: PropTypes.object
  }

  static defaultProps = {
    permissions: null,
    children: null,
    Error: <Http403 />
  }

  render() {
    const idNamespace = id("HasPermissionTo", this.props)
    const {children, Error} = this.props

    let apps = {}
    try {
      apps = this.context.authed.get().productPermissions || {}
    } catch (e) {
      /* no-op */
    }

    const hasPermission = doIHavePermission(this.props.permissions, apps)

    return (
      <div id={idNamespace}>
        {hasPermission && children}
        {!hasPermission && Error}
      </div>
    )
  }
}

export default RouteHasPermissionTo
